export default __webpack_public_path__ + "assets/images/08620d5604e472b8ede33d44c5626f71.png";